<template>
  <el-card>
    <el-row>
      <el-col :span="12">
        <el-form ref="dataForm" :model="dataForm" :rules="rules">
          <el-form-item label="名称" prop="account">
            <el-input v-model="dataForm.name" placeholder="请输入名称" :disabled="isDisable"></el-input>
          </el-form-item>

          <el-form-item label="模型字段数" prop="field_number">
            <el-input v-model="dataForm.field_number" placeholder="请输入模型字段数" :disabled="isDisable"></el-input>
          </el-form-item>
          <el-form-item label="跳过行数" prop="skip_lines">
            <el-input v-model="dataForm.skip_lines" placeholder="请输入跳过行数" :disabled="isDisable"></el-input>
          </el-form-item>

          <el-form-item label="保单号标题" prop="policy_number_title">
            <el-input v-model="dataForm.policy_number_title" placeholder="请输入保单号标题" :disabled="isDisable"></el-input>
          </el-form-item>
          <el-form-item label="保单号字段位置" prop="policy_number_pos">
            <el-input v-model="dataForm.policy_number_pos" placeholder="请输入保单号字段位置" :disabled="isDisable"></el-input>
          </el-form-item>

          <el-form-item label="保费标题" prop="premium_title">
            <el-input v-model="dataForm.premium_title" placeholder="请输入保费标题" :disabled="isDisable"></el-input>
          </el-form-item>

          <el-form-item label="保费字段位置" prop="premium_pos">
            <el-input v-model="dataForm.premium_pos" placeholder="请输入保费字段位置" :disabled="isDisable"></el-input>
          </el-form-item>

          <el-form-item label="不含税保费标题" prop="account">
            <el-input v-model="dataForm.premium_exclude_tax_title" placeholder="请输入不含税保费标题" :disabled="isDisable"></el-input>
          </el-form-item>
          <el-form-item label="不含税保费字段位置" prop="account">
            <el-input v-model="dataForm.premium_exclude_tax_pos" placeholder="请输入不含税保费字段位置" :disabled="isDisable"></el-input>
          </el-form-item>

          <el-form-item label="手续费比例标题" prop="account">
            <el-input v-model="dataForm.commission_rate_title" placeholder="请输入手续费比例标题" :disabled="isDisable"></el-input>
          </el-form-item>
          <el-form-item label="手续费比例字段位置" prop="account">
            <el-input v-model="dataForm.commission_rate_pos" placeholder="请输入手续费比例字段位置" :disabled="isDisable"></el-input>
          </el-form-item>

          <el-form-item label="手续费标题" prop="account">
            <el-input v-model="dataForm.commission_title" placeholder="请输入手续费标题" :disabled="isDisable"></el-input>
          </el-form-item>
          <el-form-item label="手续费字段位置" prop="account">
            <el-input v-model="dataForm.commission_pos" placeholder="请输入手续费字段位置" :disabled="isDisable"></el-input>
          </el-form-item>

          <el-form-item label="不含税手续费标题" prop="account">
            <el-input v-model="dataForm.commission_exclude_tax_title" placeholder="请输入不含税手续费标题" :disabled="isDisable"></el-input>
          </el-form-item>
          <el-form-item label="不含税手续费字段位置" prop="account">
            <el-input v-model="dataForm.commission_exclude_tax_pos" placeholder="请输入不含税手续费字段位置" :disabled="isDisable"></el-input>
          </el-form-item>

          <el-form-item label="备注">
            <el-input type="textarea" :rows="5" v-model="dataForm.remark" :disabled="isDisable"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12"></el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button @click="goBack">取消</el-button>
        <el-button @click="reset" v-if="pageAction === 'action.edit'">重置</el-button>
        <el-button type="primary" @click="save" v-if="pageAction === 'action.add' || pageAction === 'action.edit'">
          保存
        </el-button>
        <el-button type="primary" @click="saveAndAdd" v-if="pageAction === 'action.add'">
          保存并继续添加
        </el-button>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
import { fetchSettingBillingModel } from "@/api/billing"
import { createSettingBillingModel } from "@/api/billing"
import { updateSettingBillingModel } from "@/api/billing"
export default {
  name: 'setting-billing-model',
  data(){
    return {
      dataForm: {
        name : '测试模型',
        // insurance_company : null,
        // insurance_company_branch_office : '',

        // billing_setting_company : null,
        billing_setting_branch_office : null,

        field_number : '9',
        skip_lines : '3',

        policy_number_title : '保单号',
        policy_number_pos : '1',

        premium_title : '保费',
        premium_pos : '2',

        premium_exclude_tax_title : '不含税保费',
        premium_exclude_tax_pos : '3',

        commission_rate_title : '手续费比例',
        commission_rate_pos : '4',

        commission_title : '手续费',
        commission_pos : '5',

        commission_exclude_tax_title : '不含税手续费',
        commission_exclude_tax_pos : '6',

        remark : '备注',
      },
      tempDataForm:{},
      rules:{
        // account:[
        //   {required: true, message: '请输入账户名称', trigger: 'blur'}
        // ],
      },
      pageAction: '',
      id: 0,
      isDisable: false,
    }
  },
  methods: {
    clearDataForm: function(){
      this.dataForm.name='',

      // this.dataForm.insurance_company='',
      // this.dataForm.insurance_company_branch_office='',

      // this.dataForm.billing_setting_company='',
      this.dataForm.billing_setting_branch_office='',

      this.dataForm.field_number='',
      this.dataForm.skip_lines='',

      this.dataForm.policy_number_title='',
      this.dataForm.policy_number_pos='',

      this.dataForm.premium_title='',
      this.dataForm.premium_pos='',

      this.dataForm.premium_exclude_tax_title='',
      this.dataForm.premium_exclude_tax_pos='',

      this.dataForm.commission_rate_title='',
      this.dataForm.commission_rate_pos='',

      this.dataForm.commission_title='',
      this.dataForm.commission_pos='',

      this.dataForm.commission_exclude_tax_title='',
      this.dataForm.commission_exclude_tax_pos='',

      this.dataForm.remark=''
    },
    showAddView: function(){
      this.pageAction = 'action.add'
      this.isDisable = false
    },
    showView: function(){
      this.pageAction = 'action.view'
      this.isDisable = true
      this.getData()
    },
    showEditView: function(){
      this.pageAction = 'action.edit'
      this.isDisable = false
      this.getData()
    },
    goBack: function(){
      this.$router.go(-1)
    },
    reset: function(){
      this.dataForm = Object.assign({}, this.tempDataForm)
    },
    save: function(){
      if(this.pageAction === 'action.add'){
        this.createData(this.goBack)
      } else if(this.pageAction === 'action.edit'){
        this.updateData(null)
      }
    },
    saveAndAdd: function(){
      this.createData(this.clearDataForm)
    },
    getData: function(){
      fetchSettingBillingModel(this.id)
          .then(resp=>{
            console.log('fetchSettingBillingModel')
            console.log(resp)
            console.log('fetchSettingBillingModel')
            this.dataForm.name=resp.name

            // this.dataForm.insurance_company=resp.insurance_company
            // this.dataForm.insurance_company_branch_office=resp.insurance_company_branch_office

            // this.dataForm.billing_setting_company=resp.billing_setting_company
            this.dataForm.billing_setting_branch_office=resp.billing_setting_branch_office

            this.dataForm.field_number=resp.field_number
            this.dataForm.skip_lines=resp.skip_lines

            this.dataForm.policy_number_title=resp.policy_number_title
            this.dataForm.policy_number_pos=resp.policy_number_pos

            this.dataForm.premium_title=resp.premium_title
            this.dataForm.premium_pos=resp.premium_pos

            this.dataForm.premium_exclude_tax_title=resp.premium_exclude_tax_title
            this.dataForm.premium_exclude_tax_pos=resp.premium_exclude_tax_pos

            this.dataForm.commission_rate_title=resp.commission_rate_title
            this.dataForm.commission_rate_pos=resp.commission_rate_pos

            this.dataForm.commission_title=resp.commission_title
            this.dataForm.commission_pos=resp.commission_pos

            this.dataForm.commission_exclude_tax_title=resp.commission_exclude_tax_title
            this.dataForm.commission_exclude_tax_pos=resp.commission_exclude_tax_pos

            this.dataForm.remark=resp.remark
            this.tempDataForm = Object.assign({}, this.dataForm)
          }).catch(err=>{
        this.$error_message(err)
      })
    },
    createData: function(callBack){
      this.$refs.dataForm.validate((valid)=>{
        if(valid){
          createSettingBillingModel(this.dataForm)
              .then(resp=>{
                this.$message.success('保存账单模型信息成功')
                if (typeof callBack == 'function') {
                  callBack()
                }
              }).catch(err=>{
            this.$error_message(err)
          })
        }
      })
    },
    updateData: function(callBack){
      this.$refs.dataForm.validate((valid)=>{
        if(valid){
          updateSettingBillingModel(this.dataForm, this.id)
              .then(resp=>{
                this.tempDataForm = Object.assign({}, this.dataForm)
                this.$message.success('保存账单模型信息成功')
                if(typeof callBack == 'function'){
                  callBack()
                }
              }).catch(err=>{
            this.$error_message(err)
          })
        }
      })
    },
  },
  created(){
    if (this.$route.name === 'addSettingBillingModel'){
      if (this.$route.query.branch_office_id === undefined){
        this.$router.push('/404')
      }
      this.dataForm.billing_setting_branch_office = this.$route.query.branch_office_id
      this.showAddView()
      return
    }

    if (this.$route.query.id === undefined || this.$route.query.id === null){
      this.$router.push('/404')
    }
    this.id = this.$route.query.id
    console.log(this.id)

    if (this.$route.name === 'viewSettingBillingModel'){
      this.showView()
      return
    }

    if (this.$route.name === 'editSettingBillingModel'){
      this.showEditView()
      return
    }

    this.$router.push('/404')
  }
}
</script>
